import { getTranslate, TranslateFunction } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { payment } from '../../../../core/state/payment';
import {
  AddUserPayGreenVoucher,
  StoreRestaurantVouchers,
} from '../../../../core/state/payment/payment.types';
import { utils } from '../../../../utils';
import { basketActions, basketSelectors } from '../../../../weborder/redux';
import * as Store from '../../../../weborder/Store';
import {
  OuterProps,
  RestaurantVoucherSection as RestaurantVoucherSectionPartial,
} from './RestaurantVoucherSection';

export type StateProps = {
  canApplyRestaurantVoucher: boolean;
  canRestaurantVouchersCoverOrderAmount: boolean;
  currentLang: string;
  isRestaurantVouchersBalanceUnknown: boolean;
  menuItems: { [key: string]: { itemId: number } };
  restaurantVouchers: StoreRestaurantVouchers;
  selectedPaymentOption: ReturnType<
    typeof basketSelectors.getSelectedPaymentOrDefault
  >;
  translate: TranslateFunction;
};

export type DispatchActions = {
  addUserPayGreenVoucher: (
    payGreenVoucherScheme: string,
    storeId: number,
  ) => Promise<AddUserPayGreenVoucher>;
  getUserSavedRestaurantVoucherStatus: (
    paymentAccountId: number,
    storeId: number,
  ) => void;
  getUserSavedRestaurantVouchers: (storeId: number) => void;
  retrieveCategorizeMenuitems: (menuItemIds: number[]) => void;
  selectPaymentOption: (paymentId: string) => void;
};

export type DispatchProps = {
  actions: DispatchActions;
};

const mapStateToProps = (
  state: Store.State,
  ownProps: OuterProps,
): StateProps => {
  const { storeId, orderTotalToPay } = ownProps;
  const { canApplyRestaurantVoucher = true } = state.payments;

  const menuItems = state.basket?.items || {};

  const currentLang = utils.get.activeLanguageCode(state.locale.languages);
  const restaurantVouchers = payment.selectors.getRestaurantVouchersForStore(
    state,
    storeId,
  );
  const canRestaurantVouchersCoverOrderAmount = payment.selectors.checkRestaurantVouchersCoverOrderAmount(
    state,
    orderTotalToPay,
    storeId,
  );
  const isRestaurantVouchersBalanceUnknown = payment.selectors.checkRestaurantVouchersBalanceUnknown(
    state,
    storeId,
  );
  const selectedPaymentOption = basketSelectors.getSelectedPaymentOrDefault(
    state,
  );

  return {
    canApplyRestaurantVoucher,
    canRestaurantVouchersCoverOrderAmount,
    currentLang,
    isRestaurantVouchersBalanceUnknown,
    menuItems,
    restaurantVouchers,
    selectedPaymentOption,
    translate: getTranslate(state.locale),
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<Store.State, {}, Action>,
): DispatchProps => ({
  actions: {
    addUserPayGreenVoucher: (
      payGreenVoucherScheme: string,
      storeId: number,
    ): Promise<AddUserPayGreenVoucher> =>
      dispatch(
        payment.middleware.addUserPayGreenVoucher(
          payGreenVoucherScheme,
          storeId,
        ),
      ),

    getUserSavedRestaurantVoucherStatus: (
      paymentAccountId: number,
      storeId: number,
    ): void => {
      dispatch(
        payment.middleware.getUserSavedRestaurantVoucherStatus(
          paymentAccountId,
          storeId,
        ),
      );
    },

    getUserSavedRestaurantVouchers: (storeId: number): void => {
      dispatch(payment.middleware.getUserSavedRestaurantVouchers(storeId));
    },

    retrieveCategorizeMenuitems: (menuItemIds: number[]): void => {
      dispatch(payment.middleware.retrieveCategorizeMenuitems(menuItemIds));
    },

    selectPaymentOption: (paymentId: string): void => {
      dispatch(basketActions.selectPayment({ paymentId }));
    },
  },
});

export const RestaurantVoucherSection = connect(
  mapStateToProps,
  mapDispatchToProps,
)(RestaurantVoucherSectionPartial);
